/**
 * Utility functions for dynamic branding (logo, title) selection based on hostname
 */

import logoAygLight from "../assets/images/Brand logo/LOGOTIPO_AYG.svg";
import monogramAygLight from "../assets/images/Brand logo/MONOGRAMA_AyG.svg";
import monogramAyg from "../assets/images/Brand logo/MONOGRAMA_AyG_1.svg";
import logoAyg from "../assets/images/LOGOTIPO_AYG_v3.0.avif";
import logoRyg from "../assets/images/logo.png";
import monogramRyg from "../assets/images/monogram-ryg.svg";
import {useThemeStore} from "../store/useTheme.store";

/**
 * Checks if the current hostname belongs to AYG brand.
 * AYG is the default brand. RYG is only for raspaygana.com.ve.
 * @returns {boolean}
 */
const isAygHostname = () => {
  const hostname = window.location.hostname.replace(/^www\./, "");
  return !hostname.includes("raspaygana.com");
};

/**
 * Returns the appropriate logo based on the current hostname
 * @returns {string} The logo image path
 */
export const getLogoByHostname = () => {
  return isAygHostname() ? logoAyg : logoRyg;
};

/**
 * Returns the appropriate brand title based on the current hostname
 * @returns {string} The brand title
 */
export const getBrandTitleByHostname = () => {
  return isAygHostname() ? "Aprieta y Gana" : "Raspa y Gana";
};

/**
 * Hook to get the current logo based on hostname
 */
export const useLogo = () => {
  const theme = useThemeStore(state => state.theme);
  if (isAygHostname()) {
    return theme === "light" ? logoAygLight : logoAyg;
  }
  return logoRyg;
};

/**
 * Hook to get the current brand title based on hostname
 */
export const useBrandTitle = () => {
  return getBrandTitleByHostname();
};

export const getMonogramByHostname = () => {
  return isAygHostname() ? monogramAyg : monogramRyg;
};

export const useMonogram = () => {
  const theme = useThemeStore(state => state.theme);
  if (isAygHostname()) {
    return theme === "light" ? monogramAygLight : monogramAyg;
  }
  return monogramRyg;
};
